
import { Dealer } from '@/types/dealer';

/**
 * Creates a map of dealer_id to latest price from quotations
 */
export const createLatestPricesMap = (quotations: any[], dealersData: any[]) => {
  const latestPrices = {};
  
  if (quotations && quotations.length > 0) {
    dealersData.forEach(dealer => {
      const dealerQuotations = quotations.filter(q => q.dealer_id === dealer.id);
      if (dealerQuotations.length > 0) {
        // Use percentage spread by default
        const quotation = dealerQuotations[0];
        latestPrices[dealer.id] = quotation.spread_type === 'FIXED' 
          ? quotation.spread_fixed 
          : quotation.spread_percentage;
      }
    });
  }
  
  return latestPrices;
};

/**
 * Transforms raw dealer data to Dealer objects
 */
export const transformDealersData = (
  dealersData: any[], 
  favoritesDealers: string[],
  latestPrices: Record<string, number>
): Dealer[] => {

  return dealersData.map((dealer: any) => {
    // CRITICAL FIX: Get rating directly from average_rating field and ensure proper conversion
    let rating = 0;
    
    if (dealer.average_rating !== null && dealer.average_rating !== undefined) {
      // If it's a string, parse it
      if (typeof dealer.average_rating === 'string') {
        rating = parseFloat(dealer.average_rating);
        if (isNaN(rating)) rating = 0;
      }
      // If it's already a number, use it directly
      else if (typeof dealer.average_rating === 'number') {
        rating = dealer.average_rating;
      }
    }

    // Get rating count with proper conversion
    let rating_count = 0;
    if (dealer.rating_count !== null && dealer.rating_count !== undefined) {
      if (typeof dealer.rating_count === 'string') {
        rating_count = parseInt(dealer.rating_count);
        if (isNaN(rating_count)) rating_count = 0;
      } else if (typeof dealer.rating_count === 'number') {
        rating_count = dealer.rating_count;
      }
    }
    
    
    
    // Check if this dealer is in the user's favorites
    const isFavorite = favoritesDealers.includes(dealer.id);
    
    return {
      id: dealer.id,
      name: dealer.name,
      address: dealer.address,
      city: dealer.city,
      latitude: dealer.latitude,
      longitude: dealer.longitude,
      rating: rating,
      rating_count: rating_count, // Add rating_count field
      is_verified: dealer.activated || false, // Backwards compatibility
      activated: dealer.activated || false,
      isFavorite: isFavorite,
      buySpread: latestPrices[dealer.id] || undefined, // Keeping the property name for backward compatibility
      image_url: dealer.image_url,
      postal_code: dealer.postal_code,
      phone: dealer.phone,
      opening_hours: dealer.opening_hours,
      email: dealer.email,
      website: dealer.website,
      license: dealer.license,
      oam_verified: dealer.oam_verified || false,
      oam_code: dealer.oam_code || undefined,
      opo_code: dealer.opo_code || undefined,
      opo_verified: dealer.opo_verified || false,
      opo_registered: dealer.opo_verified || !!dealer.opo_code || dealer.opo_registered || false,
      gts_score: dealer.gts_score || undefined,
      gts_tier: dealer.gts_tier || undefined,
      oam_legal_name: dealer.oam_legal_name || undefined,
      opo_legal_name: dealer.opo_legal_name || undefined,
      ragione_sociale: dealer.ragione_sociale || undefined,
      dealer_tier: dealer.dealer_tier || undefined,
    };
  });
};
